// extracted by mini-css-extract-plugin
module.exports = {"headline":"Timer_headline__cwPk6","tooAttached":"Timer_tooAttached__2lmrf","countdownTimer":"Timer_countdownTimer__1apW5","skip":"Timer_skip__1i_Xb"};